import PropTypes from 'prop-types';
import { CurrencyPropType } from '../prop-types/currency';
import { ReturnReasonPropType } from '../prop-types/return-reason';

export const OrderItemPropType = PropTypes.shape({
  productId: PropTypes.number,
  sku: PropTypes.string,
  name: PropTypes.string,
  productThumbnailUrl: PropTypes.string,
  quantityFulfilled: PropTypes.number,
  quantity: PropTypes.number,
  quantityOrdered: PropTypes.number,
  quantityPlanned: PropTypes.number,
  quantityReturned: PropTypes.number,
  unitPrice: CurrencyPropType,
  totalPrice: CurrencyPropType,
  attributes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  returnReason: ReturnReasonPropType,
  dangerousGoods: PropTypes.arrayOf(PropTypes.object),
});

/**
 * @typedef {object} OrderItemAttributePropType
 * @property {string} name
 * @property {string} value
 */

/**
 * @typedef {object} OrderItemPropType
 * @property {number} productId
 * @property {string} sku
 * @property {string} name
 * @property {string} productThumbnailUrl
 * @property {number} quantityFulfilled
 * @property {number} quantity
 * @property {number} quantityOrdered
 * @property {number} quantityPlanned
 * @property {number} quantityReturned
 * @property {CurrencyPropType} unitPrice
 * @property {CurrencyPropType} totalPrice
 * @property {OrderItemAttributePropType[]} attributes
 * @property {ReturnReasonPropType} returnReason
 */
